export default function Marquee({ items, reverse = false, outlined = true }) {
  const content = [...items, ...items];
  return (
    <div className="relative flex overflow-hidden border-y border-white/10 bg-brand-obsidian py-6 select-none">
      <div
        className={`flex shrink-0 items-center gap-10 whitespace-nowrap ${
          reverse ? "animate-marquee-reverse" : "animate-marquee"
        }`}
      >
        {content.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-display text-4xl uppercase leading-none tracking-tight md:text-6xl ${
                outlined ? "text-stroke" : "text-white"
              }`}
            >
              {item}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand-red" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
